import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import * as firebase from 'firebase'

/**
 * Receives sessionid, and
 * title props from AdminSessionContainer
 *
 * This component deals with
 * watching, editing, dealing
 * with student stats and deleting
 * a session
 */
class AdminSession extends Component {
  constructor (props) {
    super(props)
    this.state = {
      ready: false,
      editing: false,
      text: ''

    }
    this.edit = this.edit.bind(this)
    this.deleteSession = this.deleteSession.bind(this)
    this.joinSession = this.joinSession.bind(this)
    this.handleKeyUp = this.handleKeyUp.bind(this)
    this.save = this.save.bind(this)
    this.changeSolo = this.changeSolo.bind(this)
  }

  /**
   *  handles "enter" for changing title
   * @param event
   */
  handleKeyUp = (event) => {
    console.log('AdminSession handleKeyUp ', event)
    if (event.key === 'Enter') {
      var val = this.refs.newTitle.value
      //alert(val)
      var newTitle = val //this.refs.newTitle.innerHTML;
      const titleRef = firebase.database().ref().child(this.props.institution).child('Sessions').child(this.props.sessionid).child('Info').child('Title')
      const playableRef = firebase.database().ref().child(this.props.institution).child('PlayableSessions').child(this.props.sessionid).child('Title')
      titleRef.set(newTitle)
      playableRef.set(newTitle)
      this.setState({
        // ** Update "text" property with new value (this fires render() again)
        editing: false
      })
    }
  }

  changeSolo = (event) => {
    console.log('AdminSession changeSolo ', event)
    const soloRef = firebase.database().ref().child(this.props.institution).child('PlayableSessions').child(this.props.sessionid).child('Solo')
    //const soloRef = firebase.database().ref().child(this.props.institution).child("Sessions").child(this.props.sessionid).child("Info").child("Solo");
    soloRef.once('value', snap => {
      soloRef.set(!snap.val())
    })
  }

  joinSession () {
    console.log('AdminSession joinSession')
    const UserPendingRef = firebase.database().ref().child(this.props.institution).child('Sessions').child(this.props.sessionid).child('UsersPending').child(this.props.user.uid)
    let user = {
      uid: this.props.user.uid,
      displayName: this.props.user.displayName
    }
    UserPendingRef.update(JSON.parse(JSON.stringify(user)))
  }

  /**
   * deletes session from Sessions and PlayableSessions
   */
  deleteSession () {
    //console.log("AdminSession deleteSession");
    const SessionIDRef = firebase.database().ref().child(this.props.institution).child('Sessions').child(this.props.sessionid)
    SessionIDRef.remove()
    const playableRef = firebase.database().ref().child(this.props.institution).child('PlayableSessions').child(this.props.sessionid)
    playableRef.remove()
  }

  /**
   * allows user to edit title
   */
  edit () {
    //console.log("AdminSession edit");
    this.setState({
      editing: true
    })
  }

  /**
   * handles saving title using the save button
   */
  save () {
    //console.log("AdminSession save");
    var val = this.refs.newTitle.value
    //alert(val)
    var newTitle = val //this.refs.newTitle.innerHTML;
    const titleRef = firebase.database().ref().child(this.props.institution).child('Sessions').child(this.props.sessionid).child('Info').child('Title')
    const playableRef = firebase.database().ref().child(this.props.institution).child('PlayableSessions').child(this.props.sessionid).child('Title')
    titleRef.set(newTitle)
    playableRef.set(newTitle)
    this.setState({
      // ** Update "text" property with new value (this fires render() again)
      editing: false
    })
  }

  /**
   * this render is called when not editing
   * @returns {*}
   */
  renderNormal () {
    const loadedBool = true
    //console.log("AdminSession renderNormal");
    return (
      <tr>
        <td ref="newTitle">
          {this.props.title}
        </td>
        <td>
          <Link to={{pathname: '/Simulation', state: {sessionid: this.props.sessionid}}}>
            <button
              disabled={!!(this.props.solo && this.props.user.uid !== this.props.creator)}
              onClick={this.joinSession}>
              <i className="fa fa-sign-in fa-2x"/>
            </button>
          </Link>
        </td>
        <td>
          <Link to={{pathname: '/Stats', state: {sessionid: this.props.sessionid}}}>
            <button>
              <i className="fa fa-list-ol fa-2x"/>
            </button>
          </Link>
        </td>
        <td>
          <button
            disabled={this.props.user.uid !== this.props.creator}
            onClick={this.edit}>
            <i className="fa fa-edit fa-2x"/>
          </button>
        </td>
        <td>
          <button
            className="deleteButton"
            disabled={this.props.user.uid !== this.props.creator}
            onClick={this.deleteSession}>
            <i className="fa fa-trash fa-2x"/>
          </button>
        </td>
        <td>
          {this.props.solo ? <i className="fa fa-user fa-2x"/> : <i className="fa fa-users fa-2x"/>}
        </td>
      </tr>
    )
  }

  /**
   * this render is called when editing
   * @returns {*}
   */
  renderForm () {
    //console.log("AdminSession renderForm");
    return (
      <div style={{'marginLeft': '15px'}} className='row'>
        <div className='col-xs-5'>
          <input onKeyUp={this.handleKeyUp} type='text' className='form-control mb-2 mr-sm-2 mb-sm-0'
                 ref="newTitle" defaultValue={this.props.title}/>
        </div>
        <div className='col-xs-2'>
          <button className='btn btn-default' onClick={this.save}>Save</button>
        </div>
        <br/>
      </div>
    )
  }

  /**
   * conditionally renders based on editing
   * @returns {*}
   */
  render () {
    //console.log("AdminSession render");
    if (this.state.editing) {
      return this.renderForm()
    } else {
      return this.renderNormal()
    }
  }
}

AdminSession.propTypes = {
  sessionid: PropTypes.string,
  title: PropTypes.string
}

export default AdminSession



// WEBPACK FOOTER //
// ./src/components/Dashboard/Session.js